import React from "react";
import "./productDetailsTab.css";
const ProductDetailsTab = ({ productsdetailss }) => {
  console.log(productsdetailss, "productsdetailss");

  const details = [
    // { label: "Product Type", value: productsdetailss?.name },
    { label: "Form", value: productsdetailss?.form },
    { label: "Net Quantity", value: `${productsdetailss?.quantity} Tablets` },
    { label: "Usage", value: productsdetailss?.usage },
    { label: "Suitable For", value: productsdetailss?.suitable },
  ];

  return (
    <div className="product_details_section">
      <ul>
        {details.map((item, index) => (
          <li key={index}>
            <span className="label">{item.label}:</span>
            <span className="value">{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductDetailsTab;
